import React from 'react';
import ConfirmModal from './ConfirmModal';
import './ErrorModal.css';

const ErrorModal = ({
  isOpen = false,
  onClose,
  title = 'Error',
  message,
  icon = 'exclamation triangle',
  iconColor,
  confirmText = 'OK',
  onConfirm,
  showCancel = false,
  cancelText = 'Cancel',
  type = 'error' // 'error', 'warning', 'info', 'teal'
}) => {
  // Map ErrorModal type to ConfirmModal variant
  const getVariant = () => {
    switch (type) {
      case 'error':
        return 'danger';
      case 'warning':
        return 'warning';
      default:
        return 'default';
    }
  };

  // Resolve icon color: explicit prop wins, otherwise derive from type
  const getIconColor = () => {
    if (iconColor) return iconColor;
    switch (type) {
      case 'warning':
        return 'orange';
      case 'info':
        return 'blue';
      case 'teal':
        return 'teal';
      default:
        return 'red';
    }
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    } else {
      onClose();
    }
  };

  // When showCancel is false, show only one button by omitting onConfirm
  // (ConfirmModal hides the confirm button when onConfirm is not provided).
  // The cancel button is repurposed as the OK/confirm button in this case.
  if (showCancel) {
    return (
      <ConfirmModal
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={handleConfirm}
        title={title}
        titleIconName={icon}
        titleIconColor={getIconColor()}
        confirmText={confirmText}
        cancelText={cancelText}
        confirmIconName="check"
        variant={getVariant()}
        closeOnOverlay
      >
        <div className="error-content">
          {message}
        </div>
      </ConfirmModal>
    );
  }

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={handleConfirm}
      title={title}
      titleIconName={icon}
      titleIconColor={getIconColor()}
      cancelText={confirmText}
      variant={getVariant()}
      closeOnOverlay
    >
      <div className="error-content">
        {message}
      </div>
    </ConfirmModal>
  );
};

export default ErrorModal;